// extracted by mini-css-extract-plugin
export default {"checkboxItem":"CheckboxGroup_checkboxItem__4FbwQ"};